export default __webpack_public_path__ + "static/10-sepia-a6e2c52ef2e68446afff7d14c4b96c8f.png";